module.exports = __webpack_public_path__ + "img/20190807162808037.4c80c4db.png";